import MiddleTruncate from './middle-truncate';

export default MiddleTruncate;
export { MiddleTruncate };
